export const validateRuc = ruc => {
  let suma = -(ruc % 10 < 2 ? 1 : 0);

  for (let i = 0; i < 11; i++, ruc = Math.floor(ruc / 10)) {
    suma += (ruc % 10) * ((i % 7) + Math.floor(i / 7) + 1);
  }

  return suma % 11 === 0;
};
